query PrivateFile($id: ID!) {
  file: privateFile(id: $id) {
    id
    url
  }
}
